import React, { useState, useEffect } from 'react';
import { ProgressionEngine } from '../../engine/ProgressionEngine';
import { findClue } from '../../config/discoveryCatalog';
import { Modal } from '../Modal';
import './ClueScroll.css';
export function ClueScroll({ clueId, onAcknowledge }: { clueId: string; onAcknowledge?: () => void }) {
    const clue = findClue(clueId);
    if (!clue) return null;
    const acknowledge = () => {
        ProgressionEngine.processEvent({ type: 'clue_acknowledged', payload: { clueId } });
        onAcknowledge?.();
    };
    return <Modal title="A secret to discover" onClose={acknowledge}>
        <div className="clue-reading"><img src="/ui/items/item_04.png" alt="" /><p>{clue.text}</p>
            <p className="clue-guidance">Acknowledge this clue to begin. Follow it within the next day; missed clues can return. Tap the mirror to read an active clue again. You can also use Enter on a focused secret.</p>
            <button className="action-primary" onClick={acknowledge}>I’ll follow the clue</button></div>
    </Modal>;
}
export function usePendingClue(): string | null {
    const [pending, setPending] = useState(ProgressionEngine.getPendingClue());
    useEffect(() => ProgressionEngine.subscribe(() => setPending(ProgressionEngine.getPendingClue())), []);
    return pending;
}
export default ClueScroll;
